var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPound = function SvgPound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.224 4.336c-10.378 0-18.79 8.412-18.79 18.79 0 10.377 8.412 18.788 18.79 18.788 10.377 0 18.79-8.411 18.79-18.789 0-10.377-8.413-18.79-18.79-18.79Zm-4.311 13.99a4.336 4.336 0 0 1 7.377-2.603 1.445 1.445 0 0 0 2.043-2.043 7.226 7.226 0 0 0-12.295 4.34c-.064.592 0 1.147.061 1.584l.297 2.076h-.399a1.446 1.446 0 0 0 0 2.89h.811l.267 1.858a7.227 7.227 0 0 1-.69 4.255l-.236.467a1.446 1.446 0 0 0 1.75 2.017l2.966-.986a2.89 2.89 0 0 1 1.827 0l1.262.42a5.781 5.781 0 0 0 4.413-.314l1.284-.642a1.446 1.446 0 1 0-1.291-2.586l-1.286.642a2.89 2.89 0 0 1-2.206.157l-1.26-.42a5.782 5.782 0 0 0-3.658 0l-.116.039c.232-1.138.267-2.308.102-3.457l-.208-1.45h3.496a1.445 1.445 0 0 0 0-2.89h-3.908l-.355-2.486a3.59 3.59 0 0 1-.048-.867Z",
    fill: "currentcolor"
  })));
};
export default SvgPound;